// extracted by mini-css-extract-plugin
module.exports = {"customRadio":"purposesV2_customRadio__3Ir_4","purposeSection":"purposesV2_purposeSection__M_e0c","consentsRadios":"purposesV2_consentsRadios__3Myqs"};